import { useMutation, useQueryClient } from '@tanstack/react-query';
import { CreateTicketPayload } from '../../../support';
import api from '../../http';
import { getApiErrorMessage, toApiError } from '../utils';

export function useCreateTicket() {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async (payload: CreateTicketPayload) => {
			try {
				const { data } = await api.post('/support-tickets/create', payload);
				return data;
			} catch (error) {
				throw toApiError(error, 'Erro ao criar solicitação de suporte');
			}
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['support', 'tickets'] });
		},
		onError: (error) => {
			console.error(
				'Erro ao criar solicitação de suporte:',
				getApiErrorMessage(error, 'Erro ao criar solicitação de suporte')
			);
		},
	});
}
